<template>
  <div class="dashboard-widget-settings">
    <el-form
      label-position="left"
      label-width="200px"
      style="width: 500px"
      size="mini"
    >
      <el-form-item label="Показывать встречи">
        <el-radio-group v-model="localValue.mode">
          <el-radio-button
            v-for="opt in $oneToOneConstants.meetings.modeSelectOptions"
            :key="opt.id"
            :label="opt.id"
          >{{ opt.name }}</el-radio-button>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="Статусы встреч">
        <el-select v-model="localValue.statuses" multiple clearable style="width: 100%">
          <el-option
            v-for="opt in $oneToOneConstants.meetings.statusesSelectOptions"
            :key="opt.id"
            :label="opt.name"
            :value="opt.id"
          />
        </el-select>
      </el-form-item>

      <el-form-item label="Только предстоящие">
        <el-switch v-model="localValue.onlyUpcoming"></el-switch>
      </el-form-item>

      <el-form-item label="Кол-во встреч в списке">
        <el-slider v-model="localValue.limit" :min="1" :max="30" show-input input-size="mini"></el-slider>
      </el-form-item>

      <el-form-item label="Открывать в новом окне">
        <el-switch v-model="localValue.openInNewWindow"></el-switch>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {Constants as $oneToOneConstants} from "@/modules/oneToOne/base/oneToOneConstants";

export default {
  name: 'OneToOneMeetingsWidgetSettings',
  props: {
    additionalTabs: {type: Array},
    value: {type: Object, required: true},
  },
  computed: {
    localValue: {
      get() {return this.value},
      set(value) {this.$emit('input', value)}
    },
    $oneToOneConstants() {
      return $oneToOneConstants;
    },
  },
  data() {
    return {}
  },
  methods: {}
}
</script>
